import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetTasksQuery } from '../redux/features/tasks/tasksApi';
import Task from './Task';

const TaskSList = () => {

  const { data, isError, isLoading } = useGetTasksQuery() || {};
  const {checkedCategory,searchKey}=useSelector(state=>state.filterProjects);

  const {filterProjects
  }=useSelector(state=> state);
console.log('filterProjects', filterProjects)
const dispatch= useDispatch()



  let content = null;
  if (isLoading) {
    content = <p>Loading...........</p>
  }
  else if (!isLoading && isError) {
    content = <p>Something went wrong !</p>
  }
  else if (!isLoading && !isError && data?.length > 0) {

    const showContent = data?.filter(item=>(checkedCategory.includes(item?.project?.id)))?.filter(item=>(item?.taskName?.includes(searchKey))) ||[];

    if(showContent.length == 0){
      content=<p>No Task available!</p>
    }else{
      content = showContent?.map(task => <Task task={task} key={task?.id} />)
    }
    

    
  }
  return (
    <div>


     {content}
    </div>
  )
}

export default TaskSList